import { IconLoginLogo } from "@/assets/icons/IconLoginLogo";
import { ResetPasswordForm } from "@/features/auth/components/ResetPasswordForm";
import { verifyResetTokenApi } from "@/features/auth/services/verify-reset-token-api";
import { AppRoutes } from "@/routes/config";
import { black } from "@/theme/colors";
import { getQueryFromURL } from "@/utils/url";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { FC, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const ResetPasswordPage: FC = () => {
  const query = getQueryFromURL();
  const navigate = useNavigate();

  const [isVerifying, setIsVerifying] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(false);

  const verifyToken = useCallback(async () => {
    if (!query?.email || !query?.resetToken) {
      navigate(AppRoutes.pageNotFound, { replace: true });
      return;
    }
    try {
      await verifyResetTokenApi({ email: query.email as string, resetToken: query.resetToken as string });
      setIsTokenValid(true);
    } catch (error) {
      navigate(AppRoutes.pageNotFound, { replace: true });
    } finally {
      setIsVerifying(false);
    }
  }, [query?.email, query?.resetToken, navigate]);

  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  return (
    <Stack gap="80px" alignItems="center" width="100%">
      <Stack gap={1}>
        <IconLoginLogo />
        <Stack alignItems="center" width={240} paddingY={1} bgcolor={black[30]}>
          <Typography variant="sub16Bold" color="white">
            center│システム管理
          </Typography>
        </Stack>
      </Stack>
      {isVerifying && (
        <Stack alignItems="center" justifyContent="center" py={4}>
          <CircularProgress />
        </Stack>
      )}

      {!isVerifying && isTokenValid && <ResetPasswordForm />}
    </Stack>
  );
};
